import ApiService from "@/services/api.service";
import {AuthenticationError} from "./mission.service";

const CustomerService = {

    /**
     * Returns a list of excluded customers
     * customer_id (string),
     * zipcode (string),
     * location (string),
     * excluded_date (string, date Y-m-d)
     */
    excludes: async function() {
        try {
            const params = new URLSearchParams();
            const response = await ApiService.get('/customers/excluded?' + params.toString());
            return response.data;
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data);
        }
    },

    /**
     * Sets the availability date for the logged in caregiver
     * @param availability_date "yyyy-MM-dd"
     */
    toggleExclude: async function(customer_id) {
        try {
            await ApiService.post('/customers/toggle-exclude', {
                'customer_id': customer_id
            });
        } catch (error) {
            console.log(error);
        }
    }
}

export default CustomerService

export { CustomerService }